var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception"},[_vm._v(" "+_vm._s(_vm.item.date)+" "),_c('div',{staticClass:"r"},[_c('i',{staticClass:"fas fa-times",on:{"click":_vm.clicked}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }